import * as A from '@/domain/payCategories/actions';
import { initialState } from '@/domain/payCategories/adapters';

export const reducer = {
  payCategories(state = initialState(), action) {
    switch (action.type) {
      case A.getPayCategoriesAction.type:
        return state;

      case A.getPayCategoriesAction.success: {
        return state.setIn(['list'], action.payload.list);
      }

      default:
        return state;
    }
  },
};
